import React from 'react'
import Header from '../component/Header/Header'
import HomeHero from '../component/HomeHero/HomeHero'
import Footer from '../component/Footer/Footer'
import BoxedContent from '../component/BoxedContent/BoxedContent'
import SlideScrollContent from '../component/SlideScrollContent/SlideScrollContent'
import BoostCard from '../component/BoostCard/BoostCard'
import TeamLdCare from '../component/TeamLdCare/TeamLdCare'
import HomeProgram from '../component/HomeProgram/HomeProgram'
import BoostshootRowCard from '../component/BoostshootRowCard/BoostshootRowCard'
import ServiceCards from '../component/ServiceCards/ServiceCards'
import { Helmet } from 'react-helmet'

const serviceData=[
    {
        icon:"/images/icons/service-card-icon-1.png",
        heading:"Yearly Executive Health Assessments",
        content:"In-depth screenings to stay ahead of potential health issues.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-2.png",
        heading:"Regular Follow-Ups & Coaching Calls",
        content:"Consistent touchpoints to keep your care plan on track.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-3.png",
        heading:"Global Health Support",
        content:"Seamless coordination, wherever life or business takes you.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-1.png",
        heading:"Yearly Executive Health Assessments",
        content:"In-depth screenings to stay ahead of potential health issues.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-2.png",
        heading:"Regular Follow-Ups & Coaching Calls",
        content:"Consistent touchpoints to keep your care plan on track.",
        btnText:"Learn More",
        btnRef:"/"
    },
    {
        icon:"/images/icons/service-card-icon-3.png",
        heading:"Global Health Support",
        content:"Seamless coordination, wherever life or business takes you.",
        btnText:"Learn More",
        btnRef:"/"
    },
    
]

function Service() {
  return (
    <div style={{backgroundColor:"#FEFCF0"}}>
        <Helmet>
        <title>
        Comprehensive Health & Wellness Services in Toronto
        </title>
        {/* <meta name="keywords" 
        content=""
        ></meta> */}
        <link
          rel="canonical"
          href="https://thetorontoclinic.com/service"
        />
        <meta
          name="description"
          content="The Toronto Clinic offers holistic services including audiology, orthopedic care, IV therapy, and medical aesthetics for complete well-being."
        ></meta>

      </Helmet>
         <Header/>
        <HomeHero
            heading='Specialized services that make the difference'
            content='From prevention to recovery, our diverse network of specialists offers you advanced, coordinated care, every step of the way.'
            textCtaBlack={true}
            headingBlack={true}
            showLogo={false}
            plainCta={false}
            textCenter={true}
            fullWidth={true}
            btn={false}
            // bgImage={"/images/creatives/boost-shoot-bg.png"}
            bgImage={"/images/creatives/gradient-bg-3.png"}
        />

        <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
          <div className=''></div>
          <ServiceCards
           
          />
        </div>

        {/* <div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"top",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}> */}
        
<div style={{backgroundImage:"url(/images/creatives/boxedGradient-2.png)",backgroundPosition:"bottom",backgroundSize:"cover",backgroundRepeat:"no-repeat"}}>
         <HomeProgram
            mainCardHeading="A comprehensive program designed to empower you"
            mainCardPara="At The Toronto Clinic, we champion a holistic approach to your well-being. Our program initiates with an exhaustive health assessment, spotlighting and mitigating potential risks from the onset. Our commitment ensures you not only feel your best but also thrive with vigor, confidence, and vitality."
            btnText="Explore membership"
            btnRef="/membership"
            serviceData={serviceData}
            mainCardImg={'/images/creatives/course-main-card-img.png'}
            leftBottomBorderRadius={true}
            backgroundPlain={true}
        />
        
        <Footer
          newsletterSection={false}
        />
        </div>
    </div>
  )
}

export default Service